"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var go = require("gojs/release/go");
var WallReshapingTool = (function (_super) {
    __extends(WallReshapingTool, _super);
    function WallReshapingTool() {
        var _this = _super.call(this) || this;
        var h = new go.Shape();
        h.figure = 'Diamond';
        h.desiredSize = new go.Size(12, 12);
        h.fill = 'lightblue';
        h.stroke = 'dodgerblue';
        h.cursor = 'move';
        _this._handleArchetype = h;
        _this._handle = null;
        _this._adornedShape = null;
        _this._reshapeObjectName = 'SHAPE';
        _this._angle = 0;
        _this._length = 0;
        _this._isBuilding = false;
        _this._isIntersecting = false;
        _this._joinedWalls = new go.Set();
        _this._returnPoint = null;
        _this._returnData = null;
        _this._joinedWalls = new go.Set();
        _this._wallIntersecting = null;
        return _this;
    }
    Object.defineProperty(WallReshapingTool.prototype, "handleArchetype", {
        get: function () { return this._handleArchetype; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WallReshapingTool.prototype, "handle", {
        get: function () { return this._handle; },
        set: function (value) { this._handle = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WallReshapingTool.prototype, "adornedShape", {
        get: function () { return this._adornedShape; },
        set: function (value) { this._adornedShape = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WallReshapingTool.prototype, "angle", {
        get: function () { return this._angle; },
        set: function (value) { this._angle = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WallReshapingTool.prototype, "length", {
        get: function () { return this._length; },
        set: function (value) { this._length = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WallReshapingTool.prototype, "reshapeObjectName", {
        get: function () { return this._reshapeObjectName; },
        set: function (value) { this._reshapeObjectName = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WallReshapingTool.prototype, "isBuilding", {
        get: function () { return this._isBuilding; },
        set: function (value) { this._isBuilding = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WallReshapingTool.prototype, "returnData", {
        get: function () { return this._returnData; },
        set: function (value) { this._returnData = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WallReshapingTool.prototype, "returnPoint", {
        get: function () { return this._returnPoint; },
        set: function (value) { this._returnPoint = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WallReshapingTool.prototype, "isIntersecting", {
        get: function () { return this._isIntersecting; },
        set: function (value) { this._isIntersecting = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WallReshapingTool.prototype, "wallIntersecting", {
        get: function () { return this._wallIntersecting; },
        set: function (value) { this._wallIntersecting = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WallReshapingTool.prototype, "joinedWalls", {
        get: function () { return this._joinedWalls; },
        set: function (value) { this._joinedWalls = value; },
        enumerable: true,
        configurable: true
    });
    WallReshapingTool.prototype.updateAdornments = function (part) {
        if (part === null || part instanceof go.Link)
            return;
        if (part.isSelected && !this.diagram.isReadOnly) {
            var seleltgo = part.findObject(this.reshapeObjectName);
            if (seleltgo !== null && seleltgo.part !== null && seleltgo.part.data.category === 'WallGroup') {
                var selelt = seleltgo;
                var adornment = part.findAdornment(this.name);
                if (adornment === null) {
                    adornment = this.makeAdornment(selelt);
                }
                if (adornment !== null && selelt.part !== null && selelt.geometry != null) {
                    var geo = selelt.geometry;
                    var b_1 = geo.bounds;
                    var pb_1 = selelt.part.actualBounds;
                    var graphObj = adornment.findObject('BODY');
                    if (graphObj === null)
                        return;
                    graphObj.desiredSize = b_1.size;
                    adornment.elements.each(function (h) {
                        if (h.name === undefined)
                            return;
                        var x = 0;
                        var y = 0;
                        switch (h.name) {
                            case 'sPt': {
                                x = part.data.startpoint.x - pb_1.x;
                                y = part.data.startpoint.y - pb_1.y;
                                break;
                            }
                            case 'ePt': {
                                x = part.data.endpoint.x - pb_1.x;
                                y = part.data.endpoint.y - pb_1.y;
                                break;
                            }
                        }
                        var xCheck = Math.min((x - b_1.x) / b_1.width, 1);
                        var yCheck = Math.min((y - b_1.y) / b_1.height, 1);
                        if (xCheck < 0)
                            xCheck = 0;
                        if (yCheck < 0)
                            yCheck = 0;
                        if (xCheck > 1)
                            xCheck = 1;
                        if (yCheck > 1)
                            yCheck = 1;
                        if (isNaN(xCheck))
                            xCheck = 0;
                        if (isNaN(yCheck))
                            yCheck = 0;
                        h.alignment = new go.Spot(Math.max(0, xCheck), Math.max(0, yCheck));
                    });
                    part.addAdornment(this.name, adornment);
                    adornment.location = selelt.getDocumentPoint(go.Spot.Center);
                    return;
                }
            }
        }
        part.removeAdornment(this.name);
    };
    WallReshapingTool.prototype.canStart = function () {
        if (!this.isEnabled)
            return false;
        var diagram = this.diagram;
        if (diagram === null || diagram.isReadOnly)
            return false;
        if (!diagram.allowReshape)
            return false;
        if (!diagram.lastInput.left)
            return false;
        var h = this.findToolHandleAt(diagram.firstInput.documentPoint, this.name);
        return (h !== null || this.isBuilding);
    };
    WallReshapingTool.prototype.doActivate = function () {
        var diagram = this.diagram;
        if (diagram === null)
            return;
        if (this.isBuilding) {
            if (this.adornedShape !== null && this.adornedShape.part !== null) {
                var wall = this.adornedShape.part;
                this.handle = this.findToolHandleAt(wall.data.endpoint, this.name);
                this.returnPoint = wall.data.startpoint;
            }
        }
        else {
            this.handle = this.findToolHandleAt(diagram.firstInput.documentPoint, this.name);
            if (this.handle === null)
                return;
            var adorn = this.handle.part;
            var shape = adorn.adornedObject;
            var wall = shape.part;
            if (!shape)
                return;
            this.adornedShape = shape;
            this.returnPoint = this.handle.name === 'sPt' ? wall.data.startpoint : wall.data.endpoint;
            var wallParts = wall.memberParts;
            if (wallParts.count !== 0) {
                var locationsMap_1 = new go.Map();
                wallParts.iterator.each(function (wallPart) {
                    locationsMap_1.add(wallPart.data.key, wallPart.location);
                });
                this.returnData = locationsMap_1;
            }
        }
        diagram.isMouseCaptured = true;
        this.startTransaction(this.name);
        this.isActive = true;
    };
    WallReshapingTool.prototype.doMouseMove = function () {
        var fp = this.diagram;
        var tool = this;
        if (tool.handle === null)
            return;
        var adorn = tool.handle.part;
        var wall = adorn.adornedPart;
        var mousePt = fp.lastInput.documentPoint;
        if (tool.isActive && fp !== null) {
            if (fp.lastInput.shift) {
                var type = tool.handle.name;
                var stationaryPt = (type === 'sPt') ? wall.data.endpoint : wall.data.startpoint;
                var ang = stationaryPt.directionPoint(mousePt);
                var length_1 = Math.sqrt(stationaryPt.distanceSquaredPoint(mousePt));
                ang = Math.round(ang / 45) * 45;
                var newPoint = new go.Point(stationaryPt.x + length_1, stationaryPt.y);
                var dx = stationaryPt.x;
                var dy = stationaryPt.y;
                newPoint = newPoint.offset(-dx, -dy);
                newPoint = newPoint.rotate(ang);
                newPoint = newPoint.offset(dx, dy);
                mousePt = newPoint;
            }
            var walls = fp.findNodesByExample({ category: 'WallGroup' });
            walls.iterator.each(function (w) {
                if (w.data.key !== wall.data.key) {
                    var spt = w.data.startpoint;
                    var ept = w.data.endpoint;
                    if (fp.isPointInWall(w, mousePt)) {
                        mousePt = mousePt.projectOntoLineSegmentPoint(w.data.startpoint, w.data.endpoint);
                        tool.isIntersecting = true;
                    }
                    if (Math.sqrt(spt.distanceSquaredPoint(mousePt)) < 10) {
                        mousePt = spt;
                    }
                    else if (Math.sqrt(ept.distanceSquaredPoint(mousePt)) < 10) {
                        mousePt = ept;
                    }
                }
            });
            var iw = tool.getClosestIntersectingWall(mousePt);
            if (iw === null || tool.wallIntersecting !== null) {
                if (tool.wallIntersecting !== null && tool.wallIntersecting !== undefined && tool.wallIntersecting.data !== null) {
                    tool.performMiteringOnWall(tool.wallIntersecting);
                }
            }
            if (iw != null) {
                tool.isIntersecting = true;
                tool.wallIntersecting = iw;
                mousePt = mousePt.projectOntoLineSegmentPoint(iw.data.startpoint, iw.data.endpoint);
                var distToSpt = Math.sqrt(mousePt.distanceSquaredPoint(iw.data.startpoint));
                var distToEpt = Math.sqrt(mousePt.distanceSquaredPoint(iw.data.endpoint));
                if (distToSpt < 25) {
                    mousePt = iw.data.startpoint;
                }
                else if (distToEpt < 10) {
                    mousePt = iw.data.endpoint;
                }
            }
            else {
                tool.isIntersecting = false;
                if (tool.wallIntersecting !== null && tool.wallIntersecting !== undefined &&
                    tool.wallIntersecting.data !== null && fp.getWallsIntersection(wall, tool.wallIntersecting) === null) {
                    tool.wallIntersecting = null;
                }
            }
            tool.calcAngleAndLengthFromHandle(mousePt);
            tool.reshape(mousePt);
        }
        tool.performMiteringOnWall(wall);
        fp.updateWallDimensions();
        fp.updateWallAngles();
    };
    WallReshapingTool.prototype.getClosestIntersectingWall = function (proposedPt) {
        var tool = this;
        if (tool.handle === null)
            return null;
        var adorn = tool.handle.part;
        var wall = adorn.adornedPart;
        var type = tool.handle.name;
        var stationaryPt = (type === 'sPt') ? wall.data.endpoint : wall.data.startpoint;
        var dummyWallData = {
            key: 'wall', category: 'WallGroup', caption: 'Wall', type: 'Wall', startpoint: stationaryPt,
            smpt1: stationaryPt, smpt2: stationaryPt, endpoint: proposedPt, empt1: proposedPt, empt2: proposedPt,
            thickness: parseFloat(tool.diagram.model.modelData.wallThickness), isGroup: true, notes: ''
        };
        tool.diagram.model.addNodeData(dummyWallData);
        var dummyWall = tool.diagram.findPartForKey(dummyWallData.key);
        var fp = tool.diagram;
        var walls = tool.diagram.findNodesByExample({ category: 'WallGroup' });
        var closestWall = null;
        var closestDistance = Number.MAX_VALUE;
        walls.iterator.each(function (w) {
            if (w.data.key !== wall.data.key && w.data.key !== dummyWall.data.key) {
                var intersectPoint = fp.getWallsIntersection(dummyWall, w);
                var isStationaryPtOnW = false;
                var ab = parseFloat(Math.sqrt(w.data.startpoint.distanceSquaredPoint(stationaryPt)).toFixed(2));
                var bc = parseFloat(Math.sqrt(stationaryPt.distanceSquaredPoint(w.data.endpoint)).toFixed(2));
                var ac = parseFloat(Math.sqrt(w.data.startpoint.distanceSquaredPoint(w.data.endpoint)).toFixed(2));
                if (Math.abs((ab + bc) - ac) <= .1) {
                    isStationaryPtOnW = true;
                }
                if (intersectPoint !== null && !isStationaryPtOnW) {
                    var dist = Math.sqrt(stationaryPt.distanceSquaredPoint(intersectPoint));
                    if (dist < closestDistance) {
                        closestDistance = dist;
                        closestWall = w;
                    }
                }
            }
        });
        fp.remove(dummyWall);
        return closestWall;
    };
    WallReshapingTool.prototype.pointsApproximatelyEqual = function (p1, p2) {
        var x1 = p1.x;
        var x2 = p2.x;
        var y1 = p1.y;
        var y2 = p2.y;
        var diff1 = Math.abs(x2 - x1);
        var diff2 = Math.abs(y2 - y1);
        if (diff2 < .05 && diff1 < .05) {
            return true;
        }
        return false;
    };
    WallReshapingTool.prototype.performMitering = function (wa, wb) {
        var tool = this;
        var diagram = this.diagram;
        var as = wa.data.startpoint;
        var ae = wa.data.endpoint;
        var bs = wb.data.startpoint;
        var be = wb.data.endpoint;
        var wat = wa.data.thickness;
        var wbt = wb.data.thickness;
        var wal = Math.sqrt(as.distanceSquaredPoint(ae));
        var wbl = Math.sqrt(bs.distanceSquaredPoint(be));
        var B = diagram.getWallsIntersection(wa, wb);
        if (B === null) {
            return;
        }
        var A = (tool.pointsApproximatelyEqual(as, B)) ? ae : as;
        var C = (tool.pointsApproximatelyEqual(bs, B)) ? be : bs;
        var ow = null;
        var iw = null;
        if (!tool.pointsApproximatelyEqual(as, B) && !tool.pointsApproximatelyEqual(ae, B)) {
            ow = wa;
            iw = wb;
        }
        else if (!tool.pointsApproximatelyEqual(bs, B) && !tool.pointsApproximatelyEqual(be, B)) {
            ow = wb;
            iw = wa;
        }
        if (ow !== null && iw !== null && wa.data.key === iw.data.key) {
            if (tool.isClockwise(A, B, ow.data.startpoint)) {
                C = ow.data.startpoint;
            }
            else {
                C = ow.data.endpoint;
            }
        }
        if (ow !== null && iw !== null && wb.data.key === iw.data.key) {
            if (tool.isClockwise(B, C, ow.data.startpoint)) {
                A = ow.data.startpoint;
            }
            else {
                A = ow.data.endpoint;
            }
        }
        var a1 = B.directionPoint(A);
        var a2 = B.directionPoint(C);
        var ang = Math.abs(a1 - a2 + 360) % 360;
        if (Math.abs(ang - 180) < .1) {
            return;
        }
        ang = ang * (Math.PI / 180);
        var u = Math.abs(wbt / (2 * (Math.sin(ang))));
        var v = Math.abs(wat / (2 * (Math.sin(ang))));
        var ab = Math.sqrt(A.distanceSquaredPoint(B));
        var bc = Math.sqrt(B.distanceSquaredPoint(C));
        var ux = ((A.x - B.x) / ab) * u;
        var uy = ((A.y - B.y) / ab) * u;
        var vx = ((C.x - B.x) / bc) * v;
        var vy = ((C.y - B.y) / bc) * v;
        var D = new go.Point(B.x + ux + vx, B.y + uy + vy);
        var E = new go.Point(B.x - ux - vx, B.y - uy - vy);
        var minLength = Math.min(wal, wbl);
        if (Math.sqrt(D.distanceSquaredPoint(B)) > minLength) {
            return;
        }
        var mpt = tool.isClockwise(B, A, D) ? E : D;
        if (isNaN(mpt.x) || isNaN(mpt.y)) {
            return;
        }
        if (tool.pointsApproximatelyEqual(as, B) || tool.pointsApproximatelyEqual(ae, B)) {
            var prop = null;
            if (tool.pointsApproximatelyEqual(A, as)) {
                if (tool.isClockwise(A, B, mpt)) {
                    prop = 'empt1';
                }
                else {
                    prop = 'empt2';
                }
            }
            else if (tool.pointsApproximatelyEqual(A, ae)) {
                if (tool.isClockwise(A, B, mpt)) {
                    prop = 'smpt2';
                }
                else {
                    prop = 'smpt1';
                }
            }
            if (prop !== null) {
                diagram.model.setDataProperty(wa.data, prop, mpt);
                diagram.updateWall(wa);
            }
        }
        if (tool.pointsApproximatelyEqual(bs, B) || tool.pointsApproximatelyEqual(be, B)) {
            var prop = null;
            if (tool.pointsApproximatelyEqual(C, bs)) {
                if (tool.isClockwise(C, B, mpt)) {
                    prop = 'empt1';
                }
                else {
                    prop = 'empt2';
                }
            }
            else if (tool.pointsApproximatelyEqual(C, be)) {
                if (tool.isClockwise(C, B, mpt)) {
                    prop = 'smpt2';
                }
                else {
                    prop = 'smpt1';
                }
            }
            if (prop !== null) {
                diagram.model.setDataProperty(wb.data, prop, mpt);
                diagram.updateWall(wb);
            }
        }
    };
    WallReshapingTool.prototype.getAllWallIntersectionPoints = function () {
        var tool = this;
        var diagram = tool.diagram;
        var walls = diagram.findNodesByExample({ category: 'WallGroup' });
        var intersectionPoints = new go.Set();
        walls.iterator.each(function (w) {
            var otherWalls = diagram.findNodesByExample({ category: 'WallGroup' });
            otherWalls.iterator.each(function (ow) {
                if (ow.data.key === w.data.key)
                    return;
                var ip = diagram.getWallsIntersection(w, ow);
                var doAdd = true;
                if (ip !== null) {
                    intersectionPoints.iterator.each(function (ips) {
                        var ip2 = go.Point.parse(ips);
                        if (tool.pointsApproximatelyEqual(ip2, ip)) {
                            doAdd = false;
                        }
                    });
                    if (doAdd) {
                        intersectionPoints.add(go.Point.stringify(ip));
                    }
                }
            });
        });
        return intersectionPoints;
    };
    WallReshapingTool.prototype.getAllWallsAtIntersection = function (intersectionPoint, includeDividers) {
        if (includeDividers === undefined || includeDividers === null) {
            includeDividers = true;
        }
        var tool = this;
        var diagram = tool.diagram;
        var wallsInvolved = new go.List();
        if (intersectionPoint === null) {
            return wallsInvolved;
        }
        diagram.findObjectsNear(intersectionPoint, 1, function (x) {
            if (x.part !== null) {
                return x.part;
            }
            return null;
        }, function (p) {
            if (!(p instanceof go.Group && p.category === 'WallGroup' && (includeDividers || !p.data.isDivider) && !wallsInvolved.contains(p)))
                return false;
            var s = p.data.startpoint;
            var e = p.data.endpoint;
            return tool.isPointOnSegment(s, e, intersectionPoint);
        }, true, wallsInvolved);
        return wallsInvolved;
    };
    WallReshapingTool.prototype.doWallsShareAnEndpoint = function (wa, wb) {
        var tool = this;
        var as = wa.data.startpoint;
        var ae = wa.data.endpoint;
        var bs = wb.data.startpoint;
        var be = wb.data.endpoint;
        if (tool.pointsApproximatelyEqual(as, bs) || tool.pointsApproximatelyEqual(as, be)
            || tool.pointsApproximatelyEqual(ae, bs) || tool.pointsApproximatelyEqual(ae, be)) {
            return true;
        }
        return false;
    };
    WallReshapingTool.prototype.maybeSplitWall = function () {
        var tool = this;
        if (tool.handle === null)
            return;
        var adorn = tool.handle.part;
        var reshapingWall = adorn.adornedPart;
        var movingProp = tool.handle.name;
        var movingPt = movingProp === 'sPt' ? reshapingWall.data.startpoint : reshapingWall.data.endpoint;
        var jw = tool.joinedWalls;
        var wallsAtEndpoint = tool.getAllWallsAtIntersection(movingPt);
        wallsAtEndpoint.remove(reshapingWall);
        jw.iterator.each(function (ww) {
            wallsAtEndpoint.remove(ww);
        });
        if (wallsAtEndpoint.count === 1) {
            var wallToSplit = wallsAtEndpoint.first();
            if (wallToSplit !== null) {
                if (!tool.doWallsShareAnEndpoint(reshapingWall, wallToSplit)) {
                    tool.maybePerformWallSplit(wallToSplit, movingPt);
                }
            }
        }
        if (tool.isBuilding) {
            var stationaryPt = movingPt === reshapingWall.data.startpoint ? reshapingWall.data.endpoint : reshapingWall.data.startpoint;
            var wallsAtStationaryPt = tool.getAllWallsAtIntersection(stationaryPt);
            wallsAtStationaryPt.remove(reshapingWall);
            jw.iterator.each(function (ww) {
                wallsAtEndpoint.remove(ww);
            });
            if (wallsAtStationaryPt.count === 1) {
                var wallToSplit = wallsAtStationaryPt.first();
                if (wallToSplit !== null) {
                    if (!tool.doWallsShareAnEndpoint(reshapingWall, wallToSplit)) {
                        tool.maybePerformWallSplit(wallToSplit, stationaryPt);
                    }
                }
            }
        }
        if (jw !== null) {
            jw.iterator.each(function (ww) {
                tool.splitNewWall(ww);
            });
        }
    };
    WallReshapingTool.prototype.splitNewWall = function (w) {
        var tool = this;
        var fp = this.diagram;
        var walls = fp.findNodesByExample({ category: 'WallGroup' });
        var ips = new go.Set();
        walls.iterator.each(function (ww) {
            var ip = fp.getWallsIntersection(w, ww);
            if (ip !== null) {
                ips.add(ip);
            }
        });
        ips.iterator.each(function (ip) {
            var wi = tool.getAllWallsAtIntersection(ip);
            wi.iterator.each(function (ww) {
                var s = ww.data.startpoint;
                var e = ww.data.endpoint;
                if (!tool.pointsApproximatelyEqual(s, ip) && !tool.pointsApproximatelyEqual(e, ip)) {
                    tool.maybePerformWallSplit(ww, ip);
                }
            });
        });
    };
    WallReshapingTool.prototype.maybePerformWallSplit = function (w, ip) {
        var tool = this;
        var fp = tool.diagram;
        var s = w.data.startpoint;
        var e = w.data.endpoint;
        var type = w.data.isDivider ? 'Divider' : 'Wall';
        var data1 = {
            key: 'wall', category: 'WallGroup', caption: type, type: type, color: w.data.color,
            startpoint: s, endpoint: ip, smpt1: s, smpt2: s, empt1: ip, empt2: ip,
            thickness: w.data.thickness, isGroup: true, notes: '',
            isDivider: w.data.isDivider
        };
        var data2 = {
            key: 'wall', category: 'WallGroup', caption: type, type: type, color: w.data.color,
            startpoint: ip, endpoint: e, smpt1: ip, smpt2: ip, empt1: e, empt2: e,
            thickness: w.data.thickness, isGroup: true, notes: '',
            isDivider: w.data.isDivider
        };
        var l1 = Math.sqrt(data1.startpoint.distanceSquaredPoint(data1.endpoint));
        var l2 = Math.sqrt(data2.startpoint.distanceSquaredPoint(data2.endpoint));
        var walls = fp.findNodesByExample({ category: 'WallGroup' });
        var alreadyExists = false;
        walls.iterator.each(function (wc) {
            var ws = wc.data.startpoint;
            var we = wc.data.endpoint;
            if ((tool.pointsApproximatelyEqual(s, ws) && tool.pointsApproximatelyEqual(ip, we)) ||
                (tool.pointsApproximatelyEqual(s, we) && tool.pointsApproximatelyEqual(ip, ws))) {
                alreadyExists = true;
            }
            if ((tool.pointsApproximatelyEqual(ip, ws) && tool.pointsApproximatelyEqual(e, we)) ||
                (tool.pointsApproximatelyEqual(ip, we) && tool.pointsApproximatelyEqual(e, ws))) {
                alreadyExists = true;
            }
        });
        if (l1 > 1 && l2 > 1 && !alreadyExists) {
            fp.model.addNodeData(data1);
            fp.model.addNodeData(data2);
            var w1_1 = fp.findNodeForData(data1);
            var w2_1 = fp.findNodeForData(data2);
            tool.premiterWall(w1_1);
            tool.premiterWall(w2_1);
            tool.performMiteringAtPoint(ip, false);
            if (tool.handle !== null) {
                var rooms = fp.findNodesByExample({ category: 'RoomNode' });
                var adorn = tool.handle.part;
                var rw_1 = adorn.adornedPart;
                rooms.iterator.each(function (r) {
                    var bw = r.data.boundaryWalls;
                    var _loop_1 = function (i) {
                        var entry = bw[i];
                        var wk = entry[0];
                        if (wk === w.data.key) {
                            var isConnectedToBounds_1 = false;
                            var nonIpEndpoint = (tool.pointsApproximatelyEqual(rw_1.data.startpoint, ip)) ? rw_1.data.endpoint : rw_1.data.startpoint;
                            var iw = tool.getAllWallsAtIntersection(nonIpEndpoint);
                            iw.iterator.each(function (ww) {
                                for (var j = 0; j < bw.length; j++) {
                                    var ee = bw[j];
                                    var wk2 = ee[0];
                                    if (ww.data.key === wk2 && ww.data.key !== rw_1.data.key) {
                                        isConnectedToBounds_1 = true;
                                    }
                                }
                            });
                            if (isConnectedToBounds_1) {
                                var isW1ConnectedToBounds_1 = false;
                                var w1NonIpEndpoint_1 = (tool.pointsApproximatelyEqual(w1_1.data.startpoint, ip)) ? w1_1.data.endpoint : w1_1.data.startpoint;
                                var iw2 = tool.getAllWallsAtIntersection(w1NonIpEndpoint_1);
                                iw2.remove(w);
                                iw2.iterator.each(function (ww) {
                                    var _loop_2 = function (j) {
                                        var entry2 = bw[j];
                                        var wk2 = entry2[0];
                                        if (ww.data.key === wk2 && w1_1.data.key !== ww.data.key) {
                                            var ww2_1 = fp.findNodeForKey(wk2);
                                            var ww2OtherEndpoint = (tool.pointsApproximatelyEqual(ww2_1.data.startpoint, w1NonIpEndpoint_1)) ? ww2_1.data.endpoint : ww2_1.data.startpoint;
                                            var iw3 = tool.getAllWallsAtIntersection(ww2OtherEndpoint);
                                            iw3.iterator.each(function (ww3) {
                                                for (var k = 0; k < bw.length; k++) {
                                                    var entry3 = bw[k];
                                                    var wk3 = entry3[0];
                                                    if (wk3 === ww3.data.key && wk3 !== ww2_1.data.key) {
                                                        isW1ConnectedToBounds_1 = true;
                                                    }
                                                }
                                            });
                                        }
                                    };
                                    for (var j = 0; j < bw.length; j++) {
                                        _loop_2(j);
                                    }
                                });
                                var replacementWall = (isW1ConnectedToBounds_1) ? w1_1 : w2_1;
                                var replacementEntry = tool.getUpdatedEntry(entry, replacementWall);
                                fp.startTransaction();
                                var newBounds = bw.slice();
                                newBounds[i] = replacementEntry;
                                fp.model.setDataProperty(r.data, 'boundaryWalls', newBounds);
                                fp.commitTransaction();
                            }
                            else {
                                var wi = new go.List();
                                wi.add(rw_1);
                                wi.add(w1_1);
                                wi.add(w2_1);
                                wi = fp.sortWallsClockwiseWithSetStartWall(wi, rw_1);
                                var replacementEntry2 = tool.getUpdatedEntry(entry, wi.toArray()[1]);
                                var replacementEntry1 = tool.getUpdatedEntry(entry, wi.toArray()[2]);
                                fp.startTransaction();
                                var newBounds = bw.slice();
                                newBounds.splice(i, 1, replacementEntry1);
                                newBounds.splice(i + 1, 0, replacementEntry2);
                                fp.model.setDataProperty(r.data, 'boundaryWalls', newBounds);
                                fp.commitTransaction();
                            }
                        }
                    };
                    for (var i = 0; i < bw.length; i++) {
                        _loop_1(i);
                    }
                });
            }
            var wallParts = fp.findNodesByExample({ group: w.data.key });
            var wallsSet = new go.Set();
            wallsSet.add(w1_1);
            wallsSet.add(w2_1);
            tool.maintainWallParts(wallParts, wallsSet);
            fp.remove(w);
            tool.premiterWall(w1_1);
            tool.premiterWall(w2_1);
            var w1op = tool.pointsApproximatelyEqual(w1_1.data.startpoint, ip) ? w1_1.data.endpoint : w1_1.data.startpoint;
            var w2op = tool.pointsApproximatelyEqual(w2_1.data.startpoint, ip) ? w2_1.data.endpoint : w2_1.data.startpoint;
            tool.performMiteringAtPoint(ip, false);
            tool.performMiteringAtPoint(w1op, false);
            tool.performMiteringAtPoint(w2op, false);
        }
    };
    WallReshapingTool.prototype.splitAllWalls = function () {
        var tool = this;
        var intersectionPoints = tool.getAllWallIntersectionPoints();
        intersectionPoints.iterator.each(function (ips) {
            var ip = go.Point.parse(ips);
            var wallsInvolved = tool.getAllWallsAtIntersection(ip);
            wallsInvolved.iterator.each(function (w) {
                var s = w.data.startpoint;
                var e = w.data.endpoint;
                if (!tool.pointsApproximatelyEqual(s, ip) && !tool.pointsApproximatelyEqual(e, ip)) {
                    tool.maybePerformWallSplit(w, ip);
                }
            });
        });
    };
    WallReshapingTool.prototype.areWallsParallel = function (wa, wb) {
        var tool = this;
        var fp = this.diagram;
        var as = wa.data.startpoint;
        var ae = wa.data.endpoint;
        var bs = wb.data.startpoint;
        var be = wb.data.endpoint;
        var isParallel = false;
        var a1 = +as.directionPoint(ae);
        var a2 = +bs.directionPoint(be);
        if (Math.abs(a1 - a2) < 1 || (Math.abs(a1 - a2) > 179 && Math.abs(a1 - a2) < 181)) {
            isParallel = true;
        }
        return isParallel;
    };
    WallReshapingTool.prototype.isWallColinear = function (wa, wb) {
        var tool = this;
        var fp = this.diagram;
        if (wa.data.isDivider !== wb.data.isDivider) {
            return false;
        }
        var as = wa.data.startpoint;
        var ae = wa.data.endpoint;
        var bs = wb.data.startpoint;
        var be = wb.data.endpoint;
        var isColinear = false;
        if (tool.areWallsParallel(wa, wb)) {
            var sharedEndpoint = null;
            if (tool.pointsApproximatelyEqual(as, bs) || tool.pointsApproximatelyEqual(as, be)) {
                sharedEndpoint = as;
            }
            else if (tool.pointsApproximatelyEqual(ae, bs) || tool.pointsApproximatelyEqual(ae, be)) {
                sharedEndpoint = ae;
            }
            if (sharedEndpoint !== null) {
                var wi = tool.getAllWallsAtIntersection(sharedEndpoint);
                var endpointHasNonColinearWall_1 = false;
                wi.iterator.each(function (w) {
                    if (!tool.areWallsParallel(w, wa)) {
                        endpointHasNonColinearWall_1 = true;
                    }
                });
                if (!endpointHasNonColinearWall_1) {
                    isColinear = true;
                }
            }
        }
        return isColinear;
    };
    WallReshapingTool.prototype.findAllColinearWalls = function (w, set) {
        if (set === null || set === undefined) {
            set = new go.Set();
        }
        set.add(w);
        var tool = this;
        var diagram = tool.diagram;
        var walls = diagram.findNodesByExample({ category: 'WallGroup' });
        walls.iterator.each(function (ow) {
            if (tool.isWallColinear(w, ow) && set !== undefined && !set.contains(ow)) {
                set.add(ow);
                tool.findAllColinearWalls(ow, set);
            }
        });
        return set;
    };
    WallReshapingTool.prototype.joinColinearWalls = function () {
        var tool = this;
        if (tool.handle === null)
            return;
        var adorn = tool.handle.part;
        var reshapingWall = adorn.adornedPart;
        var cw1 = tool.findAllColinearWalls(reshapingWall);
        var jw = tool.performColinearWallJoining(cw1, reshapingWall);
        if (jw !== null) {
            tool.joinedWalls.add(jw);
        }
        var wallsAtReturnPoint = tool.getAllWallsAtIntersection(tool.returnPoint);
        if (wallsAtReturnPoint.count === 2) {
            var wallsArr = wallsAtReturnPoint.toArray();
            var w1 = wallsArr[0];
            var w2 = wallsArr[1];
            if (tool.isWallColinear(w1, w2)) {
                var cw2 = new go.Set();
                cw2.add(w1);
                cw2.add(w2);
                var jw2 = tool.performColinearWallJoining(cw2, w1);
                if (jw2 !== null) {
                    tool.joinedWalls.add(jw2);
                }
            }
        }
    };
    WallReshapingTool.prototype.performColinearWallJoining = function (colinearWalls, w) {
        var tool = this;
        var fp = tool.diagram;
        var garbage = new go.Set();
        var cwf = colinearWalls.first();
        if (cwf === null) {
            return null;
        }
        if (w === undefined) {
            w = cwf;
        }
        var acceptedCategory = cwf.data.category;
        colinearWalls.iterator.each(function (cw) {
            if (cw.data.category !== acceptedCategory) {
                return;
            }
        });
        if (colinearWalls.count > 1) {
            var pt1_1 = null;
            var pt2_1 = null;
            var farthestDist_1 = 0;
            var cw2_1 = colinearWalls.copy();
            var wallParts_1 = new go.Set();
            colinearWalls.iterator.each(function (cw1) {
                var cwParts = fp.findNodesByExample({ group: cw1.data.key });
                wallParts_1.addAll(cwParts);
                cw2_1.iterator.each(function (cw2w) {
                    var s1 = cw1.data.startpoint;
                    var e1 = cw1.data.endpoint;
                    var s2 = cw2w.data.startpoint;
                    var e2 = cw2w.data.endpoint;
                    var pts1 = [s1, e1];
                    var pts2 = [s2, e2];
                    for (var i = 0; i < pts1.length; i++) {
                        var p1 = pts1[i];
                        for (var j = 0; j < pts2.length; j++) {
                            var p2 = pts2[j];
                            var dist = Math.sqrt(p1.distanceSquaredPoint(p2));
                            if (dist > farthestDist_1) {
                                farthestDist_1 = dist;
                                pt1_1 = p1;
                                pt2_1 = p2;
                            }
                        }
                    }
                });
                garbage.add(cw1);
            });
            var data = {
                key: 'wall', category: 'WallGroup', caption: 'Wall', type: 'Wall', color: w.data.color,
                startpoint: pt1_1, endpoint: pt2_1, smpt1: pt1_1, smpt2: pt1_1, empt1: pt2_1, empt2: pt2_1,
                thickness: w.data.thickness, isGroup: true, notes: '', isDivider: w.data.isDivider
            };
            fp.model.addNodeData(data);
            var newWall_1 = fp.findNodeForData(data);
            var rooms = fp.findNodesByExample({ category: 'RoomNode' });
            rooms.iterator.each(function (r) {
                var bw = r.data.boundaryWalls;
                for (var i = 0; i < bw.length; i++) {
                    var e = bw[i];
                    var wk = e[0];
                    var ww = fp.findNodeForKey(wk);
                    if (colinearWalls.contains(ww)) {
                        tool.performMiteringOnWall(newWall_1);
                        var newEntry = tool.getUpdatedEntry(e, newWall_1);
                        fp.startTransaction();
                        var newBounds = bw.slice();
                        newBounds[i] = newEntry;
                        fp.model.setDataProperty(r.data, 'boundaryWalls', newBounds);
                        fp.commitTransaction();
                    }
                }
            });
            var newWallSet = new go.Set();
            newWallSet.add(newWall_1);
            tool.performMiteringOnWall(newWall_1);
            tool.maintainWallParts(wallParts_1, newWallSet);
            garbage.iterator.each(function (ww) {
                fp.remove(ww);
            });
            tool.performMiteringOnWall(newWall_1);
            return newWall_1;
        }
        return null;
    };
    WallReshapingTool.prototype.maintainWallParts = function (wallParts, walls) {
        var tool = this;
        var fp = tool.diagram;
        var garbage = [];
        wallParts.iterator.each(function (wp) {
            var loc = wp.location;
            walls.iterator.each(function (w) {
                if (fp.isPointInWall(w, loc)) {
                    var newLoc = fp.findClosestLocOnWall(w, wp);
                    if (newLoc !== null) {
                        fp.model.setDataProperty(wp.data, 'group', w.data.key);
                        wp.location = newLoc.projectOntoLineSegmentPoint(w.data.startpoint, w.data.endpoint);
                        if (wp.category === 'WindowNode') {
                            fp.model.setDataProperty(wp.data, 'height', w.data.thickness);
                        }
                        if (wp.category === 'DoorNode') {
                            fp.model.setDataProperty(wp.data, 'doorOpeningHeight', w.data.thickness);
                        }
                    }
                    else {
                        garbage.push(wp);
                    }
                }
            });
        });
        for (var i = 0; i < garbage.length; i++) {
            fp.remove(garbage[i]);
        }
    };
    WallReshapingTool.prototype.getUpdatedEntry = function (oldEntry, nw) {
        var tool = this;
        var fp = tool.diagram;
        var oldWallKey = oldEntry[0];
        var oldWall = fp.findNodeForKey(oldWallKey);
        var oldMiteringSide = oldEntry[1];
        var newEntry = [nw.data.key, null];
        var oms = oldWall.data['smpt' + oldMiteringSide];
        var ome = oldWall.data['empt' + oldMiteringSide];
        function pointAtX(a, b, x) {
            var slope = (b.y - a.y) / (b.x - a.x);
            var y = a.y + (x - a.x) * slope;
            return new go.Point(x, y);
        }
        var pt1 = pointAtX(oms, ome, nw.data.smpt1.x);
        var pt2 = pointAtX(oms, ome, nw.data.smpt2.x);
        var dist1 = nw.data.smpt1.distanceSquaredPoint(pt1);
        var dist2 = nw.data.smpt2.distanceSquaredPoint(pt2);
        if (dist1 < dist2) {
            newEntry[1] = 1;
        }
        else {
            newEntry[1] = 2;
        }
        return newEntry;
    };
    WallReshapingTool.prototype.joinAllColinearWalls = function () {
        var tool = this;
        var diagram = tool.diagram;
        var walls = diagram.findNodesByExample({ category: 'WallGroup' });
        var handledWalls = new go.Set();
        walls.iterator.each(function (w) {
            if (!handledWalls.contains(w)) {
                handledWalls.add(w);
                var colinearWalls = new go.Set();
                colinearWalls.add(w);
                tool.findAllColinearWalls(w, colinearWalls);
                handledWalls.addAll(colinearWalls);
                tool.performColinearWallJoining(colinearWalls, w);
            }
        });
        tool.premiterAllWalls();
    };
    WallReshapingTool.prototype.translateAndRotatePoint = function (point, angle, offset) {
        var oldPoint = point.copy();
        var newPoint = point.copy();
        newPoint.offset(0, offset);
        newPoint.offset(-oldPoint.x, -oldPoint.y).rotate(angle).offset(oldPoint.x, oldPoint.y);
        return newPoint;
    };
    WallReshapingTool.prototype.premiterWall = function (w, prop) {
        var tool = this;
        var diagram = tool.diagram;
        var ang = w.data.startpoint.directionPoint(w.data.endpoint);
        var t = w.data.thickness;
        var sp = w.data.startpoint;
        var ep = w.data.endpoint;
        switch (prop) {
            case 'smpt1': {
                var smp1 = tool.translateAndRotatePoint(sp, ang, t / 2);
                diagram.model.setDataProperty(w.data, 'smpt1', smp1);
                break;
            }
            case 'smpt2': {
                var smp2 = tool.translateAndRotatePoint(sp, ang + 180, t / 2);
                diagram.model.setDataProperty(w.data, 'smpt2', smp2);
                break;
            }
            case 'empt1': {
                var emp1 = tool.translateAndRotatePoint(ep, ang, t / 2);
                diagram.model.setDataProperty(w.data, 'empt1', emp1);
                break;
            }
            case 'empt2': {
                var emp2 = tool.translateAndRotatePoint(ep, ang + 180, t / 2);
                diagram.model.setDataProperty(w.data, 'empt2', emp2);
                break;
            }
            default: {
                var emp1 = tool.translateAndRotatePoint(ep, ang, t / 2);
                diagram.model.setDataProperty(w.data, 'empt1', emp1);
                var emp2 = tool.translateAndRotatePoint(ep, ang + 180, t / 2);
                diagram.model.setDataProperty(w.data, 'empt2', emp2);
                var smp1 = tool.translateAndRotatePoint(sp, ang, t / 2);
                diagram.model.setDataProperty(w.data, 'smpt1', smp1);
                var smp2 = tool.translateAndRotatePoint(sp, ang + 180, t / 2);
                diagram.model.setDataProperty(w.data, 'smpt2', smp2);
                break;
            }
        }
        diagram.updateWall(w);
    };
    WallReshapingTool.prototype.premiterAllWalls = function () {
        var tool = this;
        var diagram = tool.diagram;
        var walls = diagram.findNodesByExample({ category: 'WallGroup' });
        walls.iterator.each(function (w) {
            tool.premiterWall(w);
        });
    };
    WallReshapingTool.prototype.performMiteringOnWall = function (w) {
        var tool = this;
        var sp = w.data.startpoint;
        var ep = w.data.endpoint;
        tool.premiterWall(w);
        tool.performMiteringAtPoint(sp, true);
        tool.performMiteringAtPoint(ep, true);
    };
    WallReshapingTool.prototype.performMiteringAtPoint = function (pt, performPremitering) {
        if (performPremitering === null || performPremitering === undefined) {
            performPremitering = true;
        }
        var tool = this;
        var fp = tool.diagram;
        var wi = tool.getAllWallsAtIntersection(pt, false);
        if (performPremitering) {
            wi.iterator.each(function (w) {
                if (tool.pointsApproximatelyEqual(w.data.startpoint, pt) || tool.pointsApproximatelyEqual(w.data.endpoint, pt)) {
                    var prop = (tool.pointsApproximatelyEqual(w.data.startpoint, pt)) ? 's' : 'e';
                    tool.premiterWall(w, prop + 'mpt1');
                    tool.premiterWall(w, prop + 'mpt2');
                }
            });
        }
        wi.sort(function (a, b) {
            var B = fp.getWallsIntersection(a, b);
            if (B === null)
                return 0;
            var as = a.data.startpoint;
            var ae = a.data.endpoint;
            var bs = b.data.startpoint;
            var be = b.data.endpoint;
            var A = tool.pointsApproximatelyEqual(pt, as) ? ae : as;
            var C = tool.pointsApproximatelyEqual(pt, bs) ? be : bs;
            var angA = B.directionPoint(A);
            var angB = B.directionPoint(C);
            if (angA > angB)
                return 1;
            else if (angA < angB)
                return -1;
            else
                return 0;
        });
        wi.reverse();
        var wiArr = wi.toArray();
        for (var i = 0; i < wiArr.length; i++) {
            var wa = wiArr[i];
            var wb = null;
            if (i + 1 === wiArr.length) {
                wb = wiArr[0];
            }
            else {
                wb = wiArr[i + 1];
            }
            tool.performMitering(wa, wb);
        }
    };
    WallReshapingTool.prototype.performAllMitering = function () {
        var tool = this;
        var diagram = tool.diagram;
        tool.premiterAllWalls();
        var intersectionPoints = tool.getAllWallIntersectionPoints();
        intersectionPoints.iterator.each(function (ips) {
            var ip = go.Point.parse(ips);
            var wallsInvolved = tool.getAllWallsAtIntersection(ip);
            wallsInvolved.sort(function (a, b) {
                var B = diagram.getWallsIntersection(a, b);
                if (B === null)
                    return 0;
                var as = a.data.startpoint;
                var ae = a.data.endpoint;
                var bs = b.data.startpoint;
                var be = b.data.endpoint;
                var A = tool.pointsApproximatelyEqual(ip, as) ? ae : as;
                var C = tool.pointsApproximatelyEqual(ip, bs) ? be : bs;
                var angA = B.directionPoint(A);
                var angB = B.directionPoint(C);
                if (angA > angB)
                    return 1;
                else if (angA < angB)
                    return -1;
                else
                    return 0;
            });
            wallsInvolved.reverse();
            var wi = wallsInvolved.toArray();
            for (var i = 0; i < wi.length; i++) {
                var wa = wi[i];
                var wb = null;
                if (i + 1 === wi.length) {
                    wb = wi[0];
                }
                else {
                    wb = wi[i + 1];
                }
                if (!wa.data.isDivider && !wb.data.isDivider) {
                    tool.performMitering(wa, wb);
                }
            }
        });
    };
    WallReshapingTool.prototype.isClockwise = function (a, b, c) {
        return ((b.x - a.x) * (c.y - a.y) - (b.y - a.y) * (c.x - a.x)) > 0;
    };
    WallReshapingTool.prototype.isPointOnSegment = function (a, b, c) {
        var ac = Math.sqrt(a.distanceSquaredPoint(c));
        var bc = Math.sqrt(b.distanceSquaredPoint(c));
        var ab = Math.sqrt(a.distanceSquaredPoint(b));
        if (Math.abs(ab - (ac + bc)) <= .1) {
            return true;
        }
        return false;
    };
    WallReshapingTool.prototype.doMouseUp = function () {
        var tool = this;
        var fp = this.diagram;
        if (tool.handle === null)
            return;
        tool.doMouseMove();
        var adorn = tool.handle.part;
        var wall = adorn.adornedPart;
        tool.joinColinearWalls();
        tool.maybeSplitWall();
        tool.joinedWalls.clear();
        var set = new go.Set();
        set.add(wall);
        fp.updateAllRoomBoundaries(set);
        this.stopTool();
    };
    WallReshapingTool.prototype.maybeCreateRoom = function () {
        var tool = this;
        if (tool.handle === null)
            return;
        var fp = this.diagram;
        var adorn = tool.handle.part;
        var wall = adorn.adornedPart;
        var reshapedPoint = tool.handle.name === 'ePt' ? wall.data.endpoint : wall.data.startpoint;
        var roomCount = fp.findNodesByExample({ category: 'RoomNode' }).count;
        if (roomCount === 0) {
            var wallsInvolved_1 = tool.getAllWallsAtIntersection(reshapedPoint);
            if (wallsInvolved_1.count === 1)
                return;
            wallsInvolved_1.sort(function (a, b) {
                var B = fp.getWallsIntersection(a, b);
                if (B === null)
                    return 0;
                var as = a.data.startpoint;
                var ae = a.data.endpoint;
                var bs = b.data.startpoint;
                var be = b.data.endpoint;
                var A = tool.pointsApproximatelyEqual(reshapedPoint, as) ? ae : as;
                var C = tool.pointsApproximatelyEqual(reshapedPoint, bs) ? be : bs;
                var angA = B.directionPoint(A);
                var angB = B.directionPoint(C);
                if (angA > angB)
                    return 1;
                else if (angA < angB)
                    return -1;
                else
                    return 0;
            });
            wallsInvolved_1.iterator.each(function (w) {
                var indexOfW = wallsInvolved_1.indexOf(w);
                var nextIndex = indexOfW + 1;
                if (nextIndex === wallsInvolved_1.length) {
                    nextIndex = 0;
                }
                var w2 = wallsInvolved_1.get(nextIndex);
                var rc = fp.findNodesByExample({ category: 'RoomNode' }).count;
                if (rc === 0) {
                    tool.tryToAddRoomBetweenTwoWalls(w, w2, reshapedPoint);
                }
            });
        }
    };
    WallReshapingTool.prototype.tryToAddRoomBetweenTwoWalls = function (w, w2, reshapedPoint) {
        var tool = this;
        var fp = tool.diagram;
        var wOtherPoint = tool.pointsApproximatelyEqual(reshapedPoint, w.data.startpoint) ? w.data.endpoint : w.data.startpoint;
        var cwOtherPoint = tool.pointsApproximatelyEqual(reshapedPoint, w2.data.startpoint) ? w2.data.endpoint : w2.data.startpoint;
        var a1 = reshapedPoint.directionPoint(wOtherPoint);
        var a2 = reshapedPoint.directionPoint(cwOtherPoint);
        var ang = Math.abs(a1 - a2 + 360) % 360;
        var ang2 = (ang + 180) % 360;
        var halfAng1 = a2 + (ang / 2) % 360;
        var halfAng2 = (halfAng1 + 180) % 360;
        var pt1 = tool.translateAndRotatePoint(reshapedPoint, halfAng1 - 90, 15);
        var pt2 = tool.translateAndRotatePoint(reshapedPoint, halfAng2 - 90, 15);
        if (!fp.maybeAddRoomNode(pt1, 'images/textures/floor1.jpg')) {
            fp.maybeAddRoomNode(pt2, 'images/textures/floor1.jpg');
        }
    };
    WallReshapingTool.prototype.doDeactivate = function () {
        var tool = this;
        var diagram = this.diagram;
        var fp = diagram;
        if (this.handle === null)
            return;
        var adorn = this.handle.part;
        var wall = adorn.adornedPart;
        var sPt = wall.data.startpoint;
        var ePt = wall.data.endpoint;
        var length = Math.sqrt(sPt.distanceSquared(ePt.x, ePt.y));
        if (length < 1) {
            diagram.remove(wall);
            wall.memberParts.iterator.each(function (member) { diagram.remove(member); });
            var wallDimensionLinkPointNodes_1 = [];
            fp.pointNodes.iterator.each(function (node) { if (node.data.key.indexOf(wall.data.key) !== -1)
                wallDimensionLinkPointNodes_1.push(node); });
            if (wallDimensionLinkPointNodes_1.length === 2) {
                diagram.remove(wallDimensionLinkPointNodes_1[0]);
                diagram.remove(wallDimensionLinkPointNodes_1[1]);
            }
        }
        if (diagram.lastInput.key === 'Esc' && !this.isBuilding) {
            diagram.skipsUndoManager = true;
            diagram.startTransaction('reset to old data');
            if (this.handle.name === 'sPt')
                wall.data.startpoint = this.returnPoint;
            else
                wall.data.endpoint = this.returnPoint;
            this.performAllMitering();
            fp.updateWall(wall);
            if (this.returnData) {
                this.returnData.iterator.each(function (kvp) {
                    var key = kvp.key;
                    var loc = kvp.value;
                    var wallPart = diagram.findPartForKey(key);
                    wallPart.location = loc;
                    wallPart.rotateObject.angle = wall.rotateObject.angle;
                });
            }
            diagram.commitTransaction('reset to old data');
            diagram.skipsUndoManager = false;
        }
        var glPoints = this.diagram.findNodesByExample({ category: 'GLPointNode' });
        diagram.removeParts(glPoints, true);
        fp.updateWallDimensions();
        tool.maybeCreateRoom();
        diagram.commitTransaction(this.name);
        this.isActive = false;
    };
    WallReshapingTool.prototype.makeAdornment = function (selelt) {
        var adornment = new go.Adornment();
        adornment.type = go.Panel.Spot;
        adornment.locationObjectName = 'BODY';
        adornment.locationSpot = go.Spot.Center;
        var h = new go.Shape();
        h.name = 'BODY';
        h.fill = null;
        h.stroke = null;
        h.strokeWidth = 0;
        adornment.add(h);
        h = this.makeHandle();
        h.name = 'sPt';
        adornment.add(h);
        h = this.makeHandle();
        h.name = 'ePt';
        adornment.add(h);
        adornment.category = this.name;
        adornment.adornedObject = selelt;
        return adornment;
    };
    WallReshapingTool.prototype.makeHandle = function () {
        var h = this.handleArchetype;
        return h.copy();
    };
    WallReshapingTool.prototype.calcAngleAndLengthFromHandle = function (mousePt) {
        var tool = this;
        var h = this.handle;
        if (h === null)
            return;
        if (tool.adornedShape === null)
            return;
        var otherH = null;
        var node = tool.adornedShape.part;
        if (node === null)
            return;
        var adornments = node.adornments.iterator;
        var adornment;
        while (adornments.next()) {
            var a = adornments.value;
            if (a.category === tool.name) {
                adornment = a;
            }
        }
        if (adornment === undefined)
            return;
        var atr = adornment.elements;
        while (atr.next()) {
            var e = atr.value;
            if (e.name !== undefined && e.name !== h.name) {
                otherH = e;
            }
        }
        if (otherH === null)
            return;
        var otherHandlePt = otherH.getDocumentPoint(go.Spot.Center);
        var deltaY = mousePt.y - otherHandlePt.y;
        var deltaX = mousePt.x - otherHandlePt.x;
        var angle = Math.atan2(deltaY, deltaX) * (180 / Math.PI);
        if (angle < 0)
            angle += 360;
        tool.angle = angle;
        var distanceBetween = Math.sqrt(mousePt.distanceSquared(otherHandlePt.x, otherHandlePt.y));
        tool.length = distanceBetween;
    };
    WallReshapingTool.prototype.snapPointToGrid = function (point) {
        var diagram = this.diagram;
        var gs = diagram.toolManager.draggingTool.isGridSnapEnabled ? diagram.model.modelData.gridSize : 1;
        var newx = gs * Math.round(point.x / gs);
        var newy = gs * Math.round(point.y / gs);
        var newPt = new go.Point(newx, newy);
        return newPt;
    };
    WallReshapingTool.prototype.reshape = function (newPoint) {
        var diagram = this.diagram;
        var tool = this;
        var shape = this.adornedShape;
        if (shape === null)
            return;
        if (tool.handle === null)
            return;
        var node = shape.part;
        if (node === null)
            return;
        if (this.diagram.lastInput.shift && !this.isIntersecting) {
            var sPt = void 0;
            if (tool.handle.name === 'sPt')
                sPt = node.data.endpoint;
            else
                sPt = node.data.startpoint;
            var oldGridSize = diagram.model.modelData.gridSize;
            var gridSize = diagram.model.modelData.gridSize;
            if (!(this.diagram.toolManager.draggingTool.isGridSnapEnabled))
                gridSize = 1;
            var angle = tool.angle;
            var length_2 = tool.length;
            if (angle > 67.5 && angle < 112.5) {
                var newy = sPt.y + length_2;
                newy = gridSize * Math.round(newy / gridSize);
                newPoint = new go.Point(sPt.x, newy);
            }
            if (angle > 112.5 && angle < 202.5) {
                var newx = sPt.x - length_2;
                newx = gridSize * Math.round(newx / gridSize);
                newPoint = new go.Point(newx, sPt.y);
            }
            if (angle > 247.5 && angle < 292.5) {
                var newy = sPt.y - length_2;
                newy = gridSize * Math.round(newy / gridSize);
                newPoint = new go.Point(sPt.x, newy);
            }
            if (angle > 337.5 || angle < 22.5) {
                var newx = sPt.x + length_2;
                newx = gridSize * Math.round(newx / gridSize);
                newPoint = new go.Point(newx, sPt.y);
            }
            if (angle > 22.5 && angle < 67.5) {
                var newx = (Math.sin(.785) * length_2);
                newx = gridSize * Math.round(newx / gridSize) + sPt.x;
                var newy = (Math.cos(.785) * length_2);
                newy = gridSize * Math.round(newy / gridSize) + sPt.y;
                newPoint = new go.Point(newx, newy);
            }
            if (angle > 112.5 && angle < 157.5) {
                var newx = (Math.sin(.785) * length_2);
                newx = sPt.x - (gridSize * Math.round(newx / gridSize));
                var newy = (Math.cos(.785) * length_2);
                newy = gridSize * Math.round(newy / gridSize) + sPt.y;
                newPoint = new go.Point(newx, newy);
            }
            if (angle > 202.5 && angle < 247.5) {
                var newx = (Math.sin(.785) * length_2);
                newx = sPt.x - (gridSize * Math.round(newx / gridSize));
                var newy = (Math.cos(.785) * length_2);
                newy = sPt.y - (gridSize * Math.round(newy / gridSize));
                newPoint = new go.Point(newx, newy);
            }
            if (angle > 292.5 && angle < 337.5) {
                var newx = (Math.sin(.785) * length_2);
                newx = sPt.x + (gridSize * Math.round(newx / gridSize));
                var newy = (Math.cos(.785) * length_2);
                newy = sPt.y - (gridSize * Math.round(newy / gridSize));
                newPoint = new go.Point(newx, newy);
            }
            gridSize = oldGridSize;
        }
        if (this.diagram.toolManager.draggingTool.isGridSnapEnabled && !tool.isIntersecting && !this.diagram.lastInput.shift) {
            newPoint = this.snapPointToGrid(newPoint);
        }
        else {
            newPoint = new go.Point(newPoint.x, newPoint.y);
        }
        var type = tool.handle.name;
        if (type === undefined)
            return;
        var stationaryPt = (type === 'sPt') ? node.data.endpoint : node.data.startpoint;
        var movingPt = (type === 'sPt') ? node.data.startpoint : node.data.endpoint;
        this.reshapeWall(node, stationaryPt, movingPt, newPoint, diagram);
        this.updateAdornments(node);
        this.showMatches();
        var fp = diagram;
        fp.updateWallDimensions();
    };
    WallReshapingTool.prototype.showMatches = function () {
        var tool = this;
        var diagram = tool.diagram;
        if (!diagram.model.modelData.preferences.showWallGuidelines)
            return;
        if (tool.adornedShape === null)
            return;
        if (tool.handle === null)
            return;
        var wall = tool.adornedShape.part;
        var comparePt;
        if (tool.handle.name === 'sPt')
            comparePt = wall.data.startpoint;
        else
            comparePt = wall.data.endpoint;
        var hWall = tool.adornedShape.part;
        var glPoints = diagram.findNodesByExample({ category: 'GLPointNode' });
        diagram.removeParts(glPoints, true);
        var walls = this.diagram.findNodesByExample({ category: 'WallGroup' });
        walls.iterator.each(function (w) {
            if (hWall !== null && w.data.key !== hWall.data.key) {
                var shape = w.findObject('SHAPE');
                var pt1 = w.data.startpoint;
                var pt2 = w.data.endpoint;
                tool.checkPtLinedUp(pt1, comparePt.x, pt1.x, comparePt);
                tool.checkPtLinedUp(pt1, comparePt.y, pt1.y, comparePt);
                tool.checkPtLinedUp(pt2, comparePt.x, pt2.x, comparePt);
                tool.checkPtLinedUp(pt2, comparePt.y, pt2.y, comparePt);
            }
        });
    };
    WallReshapingTool.prototype.checkPtLinedUp = function (pt, comparePtCoord, ptCoord, comparePt) {
        function makeGuideLinePoint() {
            var $ = go.GraphObject.make;
            return $(go.Node, 'Spot', { locationSpot: go.Spot.TopLeft, locationObjectName: 'SHAPE', desiredSize: new go.Size(1, 1) }, new go.Binding('location', 'loc', go.Point.parse).makeTwoWay(go.Point.stringify), $(go.Shape, { stroke: null, strokeWidth: 1, name: 'SHAPE', fill: 'black' }));
        }
        function makeGuideLineLink() {
            var $ = go.GraphObject.make;
            return $(go.Link, $(go.Shape, { stroke: 'black', strokeWidth: 2, name: 'SHAPE' }, new go.Binding('strokeWidth', 'width'), new go.Binding('stroke', 'stroke')));
        }
        var diagram = this.diagram;
        var errorMargin = Math.abs(comparePtCoord - ptCoord);
        if (errorMargin < 2) {
            var data = { category: 'GLPointNode', loc: go.Point.stringify(pt), key: 'glpt' };
            var data2 = { key: 'movingPt', category: 'GLPointNode', loc: go.Point.stringify(comparePt) };
            var data3 = { key: 'guideline', category: 'guideLine', from: 'movingPt', to: data.key, stroke: 'blue' };
            var GLPoint1 = makeGuideLinePoint();
            var GLPoint2 = makeGuideLinePoint();
            var GLLink = makeGuideLineLink();
            diagram.add(GLPoint1);
            diagram.add(GLPoint2);
            diagram.add(GLLink);
            GLPoint1.data = data;
            GLPoint2.data = data2;
            GLLink.data = data3;
            GLLink.fromNode = GLPoint1;
            GLLink.toNode = GLPoint2;
        }
    };
    WallReshapingTool.prototype.reshapeWall = function (wall, stationaryPoint, movingPoint, newPoint, diagram) {
        var tool = this;
        var wallParts = wall.memberParts;
        var arr = [];
        var oldAngle = wall.data.startpoint.directionPoint(wall.data.endpoint);
        wallParts.iterator.each(function (part) { arr.push(part); });
        var distancesMap = new go.Map();
        var closestPart = null;
        var closestDistance = Number.MAX_VALUE;
        for (var i = 0; i < arr.length; i++) {
            var part = arr[i];
            var distanceToStationaryPt = Math.sqrt(part.location.distanceSquaredPoint(stationaryPoint));
            distancesMap.add(part.data.key, distanceToStationaryPt);
            var endpoints = tool.getWallPartEndpoints(part);
            var distanceToMovingPt = Math.min(Math.sqrt(endpoints[0].distanceSquaredPoint(movingPoint)), Math.sqrt(endpoints[1].distanceSquaredPoint(movingPoint)));
            if (distanceToMovingPt < closestDistance) {
                closestDistance = distanceToMovingPt;
                closestPart = part;
            }
        }
        if (closestPart !== null) {
            var loc = closestPart.location;
            var partLength = closestPart.data.length;
            var angle = oldAngle;
            var point1 = new go.Point((loc.x + (partLength / 2)), loc.y);
            var point2 = new go.Point((loc.x - (partLength / 2)), loc.y);
            point1.offset(-loc.x, -loc.y).rotate(angle).offset(loc.x, loc.y);
            point2.offset(-loc.x, -loc.y).rotate(angle).offset(loc.x, loc.y);
            var distance1 = Math.sqrt(stationaryPoint.distanceSquaredPoint(point1));
            var distance2 = Math.sqrt(stationaryPoint.distanceSquaredPoint(point2));
            var minLength = void 0;
            var newLoc = void 0;
            if (distance1 > distance2) {
                minLength = distance1;
                newLoc = point1;
            }
            else {
                minLength = distance2;
                newLoc = point2;
            }
            var testDistance = Math.sqrt(stationaryPoint.distanceSquaredPoint(newPoint));
            if (testDistance < minLength)
                newPoint = newLoc;
        }
        if (movingPoint === wall.data.endpoint) {
            diagram.model.setDataProperty(wall.data, 'endpoint', newPoint);
        }
        else {
            diagram.model.setDataProperty(wall.data, 'startpoint', newPoint);
        }
        var fp = diagram;
        fp.updateWall(wall);
        distancesMap.iterator.each(function (kvp) {
            var wallPart = diagram.findPartForKey(kvp.key);
            var distance = kvp.value;
            var wallLength = Math.sqrt(stationaryPoint.distanceSquaredPoint(movingPoint));
            var newLoc = new go.Point(stationaryPoint.x + ((distance / wallLength) * (movingPoint.x - stationaryPoint.x)), stationaryPoint.y + ((distance / wallLength) * (movingPoint.y - stationaryPoint.y)));
            wallPart.location = newLoc;
            var sToE = wall.data.startpoint.directionPoint(wall.data.endpoint);
            var eToS = wall.data.endpoint.directionPoint(wall.data.startpoint);
            var diffS = Math.abs(wallPart.angle - sToE);
            var diffE = Math.abs(wallPart.angle - eToS);
            var newAngle = (diffS < diffE) ? sToE : eToS;
            wallPart.angle = newAngle;
        });
    };
    WallReshapingTool.prototype.getWallPartEndpoints = function (wallPart) {
        var loc = wallPart.location;
        var partLength = wallPart.data.length;
        var angle = 0;
        if (wallPart.containingGroup !== null)
            angle = wallPart.containingGroup.rotateObject.angle;
        else
            angle = 180;
        var point1 = new go.Point((loc.x + (partLength / 2)), loc.y);
        var point2 = new go.Point((loc.x - (partLength / 2)), loc.y);
        point1.offset(-loc.x, -loc.y).rotate(angle).offset(loc.x, loc.y);
        point2.offset(-loc.x, -loc.y).rotate(angle).offset(loc.x, loc.y);
        var arr = [];
        arr.push(point1);
        arr.push(point2);
        return arr;
    };
    return WallReshapingTool;
}(go.Tool));
exports.WallReshapingTool = WallReshapingTool;
